<template>
  <div class="invoice-header d-flex flex-wrap justify-space-between flex-column flex-sm-row">
    <!-- Left Content -->
    <div class="mb-8 mb-sm-0">
      <div class="d-flex align-center mb-6">
        <img :src="appLogo" alt="logo" class="me-3">
      </div>
    </div>
    <!-- Right Content -->
    <div>
        <span class="d-block">SIA LeadProm Media</span>
        <span class="d-block">{{ companyAddress }}</span>
        <span class="d-block">Reg. number 40203230340</span>
        <span class="d-block">VAT LV40203230340</span>
        <span class="d-block">Email: billing@leadprom.com</span>
      </div>
  </div>
</template>

<script>
import themeConfig from '@themeConfig';

export default {
  props: {
    date: { type: String, required: true },
  },
  setup(props) {
    const invoiceDate = new Date(props.date);
    const dateNewAddress = new Date('2026-04-28');
    const companyAddress = invoiceDate < dateNewAddress ? 'Matīsa iela, 61 - 31, Rīga, Latvia, LV-1009' : 'Marijas iela 2A, Rīga, Latvia, LV-1050';

    return {
      appLogo: themeConfig.app.logo,
      companyAddress,
    };
  },
};
</script>
